module.exports = __webpack_public_path__ + "static/media/cuna_int_larga.1c4edcc7.png";